import React from 'react'

const SuspendedScreen = () => {
  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.iconWrap}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            style={styles.icon}
          >
            <rect x='3' y='11' width='18' height='11' rx='2' ry='2' />
            <path d='M7 11V7a5 5 0 0 1 10 0v4' />
          </svg>
        </div>
        <h1 style={styles.title}>Account Suspended</h1>
        <p style={styles.subtitle}>
          Your organisation's account has been suspended and access to this
          platform has been temporarily disabled.
        </p>
        <p style={styles.body}>
          Please reach out to your administrator to resolve this.
        </p>
        <div style={styles.divider} />
        <p style={styles.contact}>
          <span style={styles.contactLabel}>Need help?</span>&nbsp; Contact your
          system administrator to restore access.
        </p>
      </div>
    </div>
  )
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '56px 48px',
    maxWidth: '480px',
    width: '90%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.10)',
  },
  iconWrap: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    background: '#fff4f4',
    margin: '0 auto 28px',
    color: '#e05252',
  },
  icon: {
    width: '36px',
    height: '36px',
  },
  title: {
    fontSize: '26px',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 12px',
    letterSpacing: '-0.3px',
  },
  subtitle: {
    fontSize: '15px',
    color: '#555770',
    lineHeight: '1.6',
    margin: '0 0 16px',
  },
  body: {
    fontSize: '14px',
    color: '#888a9e',
    lineHeight: '1.7',
    margin: '0',
  },
  divider: {
    height: '1px',
    background: '#f0f1f5',
    margin: '28px 0',
  },
  contactLabel: {
    fontWeight: '600',
    color: '#1a1a2e',
  },
  contact: {
    fontSize: '14px',
    color: '#888a9e',
    margin: '0',
  },
}

export default SuspendedScreen
